import videojs from 'video.js'
import th from 'video.js/dist/lang/th.json'

videojs.addLanguage('th', th)
videojs.addLanguage('th', {
  'Error': 'ข้อผิดพลาด',
  'Error Code': 'รหัสข้อผิดพลาด',

  // custom thai translations
  'subtitles off': 'ปิด',
  'captions off': 'ปิด',
  'audio off': 'ปิด',
  'Default': 'ค่าเริ่มต้น',
  'Unknown': 'ค่าเริ่มต้น',
  'subtitles_unavailable': 'ไม่มีคำบรรยาย',
  'character_edge_style': 'รูปแบบขอบตัวอักษร',
  'window_opacity': 'ความทึบของหน้าต่าง',
  'window_color': 'สีของหน้าต่าง',
  'background_opacity': 'ความทึบของพื้นหลัง',
  'background_color': 'สีของพื้นหลัง',
  'font_opacity': 'ความทึบของแบบอักษร',
  'font_size': 'ขนาดตัวอักษร',
  'font_color': 'สีตัวอักษร',
  'font_family': 'ตระกูลแบบอักษร',
  'custom_setting': 'การตั้งค่าแบบกำหนดเอง',
  'Try again': 'ลองอีกครั้ง',
  'button_try_again_in': 'ลองอีกครั้งใน {1}',
  'too_many_streams_title': 'มีการสตรีมมากเกินไป',
  'stream_limit_exceeded_message':
    'การสมัครสมาชิกของคุณอนุญาตให้สตรีมพร้อมกันได้ {1} รายการ โปรดหยุดการเล่นบนอุปกรณ์อื่นแล้วลองอีกครั้ง',
})
